import * as React from 'react';
import * as style from './ReviewsTeaserLayout.css';
import { Layout } from '../Layout';

export const ReviewsTeaserLayout = ({ children }: React.PropsWithChildren<{}>) => {
  return (
    <div className={style['reviews']}>
      <Layout>
        <div data-nav-tab="reviews/Отзывы" id="reviews" className={style['nav_container']}>
          {children}
        </div>
      </Layout>
    </div>
  );
};
